<template>
  <div>
    <div class="nav-height">
      <div class="col-12 ml-3 ml-lg-1 no-gutters d-flex justify-content-between">
        <div class="col-lg-4 col-5 col-md-5 mt-3 mr-md-3 mr-1 searchinput  ml-lg-0 " v-if="userType !== 'InternalUser'">
          <div class="input-group mb-3 search-input" :class="{'input-width':activeField === true}"  v-click-outside="hide" @click="searchClicked">
            <!-- only for large devices -->
            <div class="input-group-prepend d-none d-lg-block" >
              <span class="input-group-text img-input-group" id="basic-text">
                <img :src="searchimg" class="imgborder" alt="search"/> 
              </span>
            </div>
            <input
              class="form-control input-border d-none d-lg-block"
              type="text"  :class="{'input-border' :activeField === false }"
              placeholder="Search Job,people,more..."  id="searchedInput" autocomplete="off"
              aria-label="Search" @keyup="searchByUsername()" v-model="searchText"    @focus="activeField = true"
            />
            <div class="input-group-append d-none d-lg-block" v-if="searchText.length > 0">
              <span class="img-input-group hover" id="basic-text1" >
                <img src="../assets/Close.svg" class="imgborder1 " alt="close" @click ="hide">
              </span>
            </div>
            <!-- only for small devices -->
            <div class="input-group-prepend d-block d-lg-none" v-if="!activeField">
              <span class="input-group-text img-input-group" id="basic-text">
                <img :src="searchimg" class="imgborder" alt="search"/> 
              </span>
            </div>
            <input
              class="form-control input-border d-block d-lg-none"
              type="text"  :class="{'input-border' :activeField === false }"
              placeholder="Search Job,people,more..."  id="searchedInput" autocomplete="off"
              aria-label="Search" @keyup="searchByUsername()" v-model="searchText"    @focus="activeField = true"
            />
            <div class="input-group-append d-block d-lg-none" v-if="activeField">
              <!-- style searchsubmit for top dev -->
              <!-- <span class="img-input-group hover proximanova" id="basic-text1" @click="searchByUsername()"> submit
              </span> -->
              <img src="../assets/Search_white.png" class="imgborder1 searchsubmit" alt="close" @click ="searchByUsername()">
            </div>
            <div class="dropdown-menu" id = "dropdown" v-if="searchText.length >= 0 && activeField">   
              <nav class="nav mb-1">
                <div class="row no-gutters nav-opacity">
                  <ul class="nav nav-tabs proximanova-semibold fontsize12 black60">
                    <li class="ml-2 mr-1 pointer"> 
                      <a class="list-Font-color border-color"
                      :class="{'proximanova-semibold blue colored-border':searchType == 'people'}"
                      id="people" @click="toggleActiveSearchClass('people')"                           
                      >People</a>
                    </li>
                    <li class="ml-1 mr-1 pointer"> 
                      <a class="list-Font-color border-color"
                      :class="{'proximanova-semibold blue colored-border' :searchType == 'company'}"
                      id="company"  @click="toggleActiveSearchClass('company')"                      
                      >Company</a>
                    </li>
                    <li class="ml-1 mr-1 pointer"> 
                      <a  class="list-Font-color border-color"
                      :class="{'proximanova-semibold blue colored-border':searchType == 'job'}"
                      id="job"  @click="toggleActiveSearchClass('job')"                             
                      >Job</a>
                    </li>
                  </ul>
                </div>
              </nav>
              <div class="line1"></div>  
              <div v-if="globalSearchLoader">
                <img src="../assets/loading_gif1.gif" class="instanceloader pt-3 pb-3" alt="loading">
              </div>  
              <div class="fontsize12 black60 proximanova col-12 bigger-font" v-else>
                <div v-if="searchType === 'people'">
                  <div v-if="searchList.length > 0">
                  <li class="list-group-item d-flex" id="searchList" v-for="item in searchList" :key="item.profileId" v-on:click="selectedUser(item.aliasLink)">
                    <img :src="item.profilePictureLink" oncontextmenu="return false" v-if="item.profilePictureLink" @error="item.profilePictureLink = null" class="img-fluid rounded-circle loadingBgImg" id="profImage" alt="profilepic">
                    <!-- <img v-else class="img-fluid rounded-circle" id="profImage" src="../assets/Profile_placehlder.svg" > -->
                    <div id="profImage" class="othercircles text-center white fontsize14 rounded-circle white" :class="item.firstName.charAt(0)" v-else>
                      <!-- {{item.firstName.charAt(0)}} -->
                      <span class="white fontsize14 defmargintop text-uppercase">{{item.firstName.charAt(0)}}</span>
                    </div>
                    <span class="ml-2 hover mt-1" >{{item.firstName}} {{item.lastName}}   </span>
                  </li>
                  <div class="proximanova black80 fontsize14 colored-border d-flex justify-content-center hover">
                    <a  @click="allPeopleResults(searchText,searchList.length)" >See all Results</a>
                  </div>
                  </div>
                  <div v-else>
                    <span class="proximanova black80 fontsize14 pt-3 pb-3 d-flex justify-content-center" v-if="searchText.length>2">No Records Found</span>
                  </div>
                </div>
                <div v-if="searchType === 'job'">
                  <!-- <li class="list-group-item " id="searchList" v-for="(item,index) in jobsList" @click="routeToJobs()" :key="index">                    
                    <img class="img-fluid rounded-circle" src="../assets/Search.svg">
                    <span class="ml-2 hover " >{{item}}   </span> 
                  </li> -->
                  <div v-if="searchList.length > 0">
                  <li class="list-group-item " id="searchList" v-for="(item, index) in searchList" :key="index" v-on:click="selectedJob(item)">
                    <img :src="item.companyLogoLink" oncontextmenu="return false" v-if="item.companyLogoLink" class="img-fluid rounded-circle loadingBgImg" id="profImage" alt="companylogo">
                    <img v-else class="img-fluid rounded-circle" id="profImage" src="../assets/Profile_placehlder.svg" alt="companylogo">
                    <span class="ml-2 hover" >{{item.jobTitle}}   </span>
                  </li>
                  <div class="proximanova black80 fontsize14 colored-border d-flex justify-content-center hover">
                    <a @click="allJobResults(searchText,searchList.length)">See all Results</a>
                  </div>
                  </div>
                  <div v-else>
                    <span class="proximanova black80 fontsize14 pt-3 pb-3 d-flex justify-content-center" v-if="searchText.length>2">No Records Found</span>
                  </div>
                </div>
                <div v-if="searchType === 'company'">
                  <div v-if="searchList.length > 0">
                  <li class="list-group-item " id="searchList" v-for="(item, index) in searchList" :key="index" v-on:click="selectedCompany(item.aliasName)">
                    <img :src="item.companyLogoLink" oncontextmenu="return false" v-if="item.companyLogoLink" class="img-fluid rounded-circle loadingBgImg" id="profImage" alt="companylogo">
                    <img v-else class="img-fluid rounded-circle" id="profImage" src="../assets/Profile_placehlder.svg" alt="companylogo">
                    <span class="ml-2 hover" >{{item.companyName}}   </span>
                  </li>
                  <div class="proximanova black80 fontsize14 colored-border d-flex justify-content-center hover">
                    <a @click="allCompanyResults(searchText,searchList.length)">See all Results</a>
                  </div>
                  </div>
                  <div v-else>
                    <span class="proximanova black80 fontsize14 pt-3 pb-3 d-flex justify-content-center" v-if="searchText.length>2">No Records Found</span>
                  </div>
                </div>
              </div>             
            </div>
            <!-- <div class="line"></div> -->
            <!-- <hr> -->
            <!-- <div class="line-opacity-4 mr-3 mt-2 mb-2"></div> -->
          </div>
        </div>
        <div class="col-lg-5 mt-3 mr-lg-0 mr-sm-2 d-none d-md-none d-lg-block">
          
          <span class="postbtn proximanova-semibold fontsize12"  v-if="userType !== 'InternalUser'" @mouseover="changepostimage1" @mouseout="changepostimage2" @click="openPostAVideoModal">
            <img :src="postavideo" class="img-fluid mr-2" alt="postvideo"/>
            <label id="postavideotext">Post A Video</label>
          </span>
          <span class="postbtn proximanova-semibold fontsize12"  v-if="userType !== 'InternalUser'" @mouseover="changejobimage1" @mouseout="changejobimage2" v-popover:business>
            <img :src="businessIcon" id="postajob" class="imd-fluid ml-3 mr-2" alt="postjob"/>
            <label id="postajobtext">Products</label>
          </span>
          <!-- <button class="btn btn-light ml-2 text-center mt-2 tryPremiumbtn sign-in-button" @click="TryPremium">
            <span v-if="remainingDaysLeft>0">{{remainingDaysLeft}} days Left</span><span v-else>Try Premium </span>
          </button> -->
        </div>
        <popover name="business" class="col-md-4 businesspopover">
          <div class="column">
            <div class="ml-0 mb-2 p-1 d-flex pointer mouseoveraction1" @click="moveToBusinessAccount" @mouseover="mouseoverBusinessAccount" @mouseout="mouseleaveBusinessAccount">
              <img :src="businessAccountSvg" class="imd-fluid mr-2" alt="business"/>
              <label class="ml-2 fontsize12 proximanova-semibold black margintop1">Company Account</label>
            </div>
            <div class="horizontalline"></div>
            <div class="ml-0 mb-2 mt-2 p-1 d-flex pointer mouseoveraction1" @click="moveToPostJobModule" @mouseover="mouseoverPostaJob" @mouseout="mouseleavePostaJob">
              <img :src="postaJobSvg" class="imd-fluid mr-2" alt="postjob"/>
              <label class="ml-2 fontsize12 proximanova-semibold black margintop1">Recruiter</label>
            </div>
            <!-- <div class="horizontalline"></div>
            <div class="ml-0 mb-2 mt-2 p-1 d-flex pointer mouseoveraction1" @mouseover="mouseoverRecruiter" @mouseout="mouseleaveRecruiter">
              <img :src="recruiterSvg" class="imd-fluid mr-2" />
              <label class="ml-2 fontsize12 proximanova-semibold black margintop1">Recruiter</label>
            </div> -->
            <div class="horizontalline"></div>
            <div class="text-center mt-2">
              <span class="forgot-password pointer" @click="moveToBusinessSignUp">Create Business Account</span>
            </div>
          </div>
        </popover>
        <div class="mt-3 mr-1 ml-1 col-md-1 d-block text-center  d-sm-block d-md-block d-lg-none"  v-if="userType !== 'InternalUser'">
          <button class="border-0 businessbtn pl-2 pb-1">
            <div class="d-flex" v-popover:foo2>
              <img :src="businessIcon" alt="business" class="" width="40px"/>
              <!-- <label for="" class="font12-bold mt-2 ml-1 d-none d-md-block">Business</label> -->
            </div>
            <popover name="foo2" class="col-md-4 postpopover">
              <div class="column">
                <div class="ml-0 mb-2 p-1 d-flex pointer mouseoveraction1" @click="moveToBusinessAccount" @mouseover="mouseoverBusinessAccount" @mouseout="mouseleaveBusinessAccount">
                  <img :src="businessAccountSvg" class="imd-fluid mr-2" alt="business"/>
                  <label class="ml-2 fontsize12 proximanova fontbold black margintop1">Company Account</label>
                </div>
                <div class="horizontalline"></div>
                <div class="ml-0 mb-2 mt-2 p-1 d-flex pointer mouseoveraction1" @click="moveToPostJobModule" @mouseover="mouseoverPostaJob" @mouseout="mouseleavePostaJob">
                  <img :src="postaJobSvg" class="imd-fluid mr-2" alt="postjob"/>
                  <label class="ml-2 fontsize12 proximanova fontbold black margintop1">Recruiter</label>
                </div>
                <!-- <div class="horizontalline"></div>
                <div class="ml-0 mb-2 mt-2 p-1 d-flex pointer mouseoveraction1" @mouseover="mouseoverRecruiter" @mouseout="mouseleaveRecruiter">
                  <img :src="recruiterSvg" class="imd-fluid mr-2" />
                  <label class="ml-2 fontsize12 proximanova fontbold black margintop1">Recruiter</label>
                </div> -->
                <div class="horizontalline"></div>
                <div class="text-center mt-2 mb-2">
                  <span class="forgot-password proximanova fontsize14 pointer" @click="moveToBusinessSignUp">Create Business Account</span>
                </div>
              </div>
            </popover>
          </button>
        </div>
        <postvideomodal v-if="postavideomodalopen" @close = "closeModal"></postvideomodal>
        <div class="d-flex col-md-5 col-lg-2 mr-lg-4 justify-content-sm-start justify-content-lg-between" :class="{'internalUserstyles' :userType == 'InternalUser'}">
          <div class="mt-3 ml-1 mr-1 mr-md-3 ml-md-3">
            <div class="mouseover" v-if="!profilePictureLink && !firstName">
              <img
                v-popover:foo1
                src="../assets/AddPhoto.svg"
                class="img-lg-fluid usericon rounded-circle"
                id="profilepopupimg"
                width="35px"
                height="35px"
                alt="add"
              />
            </div>
            <div v-if="!profilePictureLink && firstName" v-popover:foo1 id="profilepopupimg" class="defimgmouseover text-center white fontsize14 profile-border usericon1 rounded-circle white" :class="firstName.charAt(0)">
              <p class="white fontsize14 defmargintop userprofilepic text-uppercase">{{firstName.charAt(0)}}</p>
            </div>
            <div v-if="profilePictureLink" class="profile-border mouseover">
              <img :src="profilePictureLink" v-popover:foo1 id="profilepopupimg" @error="profilePictureLink = null" alt="profilepic" class="img-lg-fluid userproicon rounded-circle loadingBgImg">
            </div>
            <popover name="foo1" class="userpopover">
              <div class="p-2">
                <div class="row no-gutters">
                  <div class="col-3" v-if="firstName">
                    <!-- <img v-if="!profilePictureLink" src="../assets/Profile_placehlder.svg" class="img-fluid" /> -->
                    <div v-if="!profilePictureLink" v-popover:foo1 id="profilepopupimg" class="mouseover text-center white fontsize14 profile-border usericon2 rounded-circle white" :class="firstName.charAt(0)">
                      <p class="white fontsize14 defmargintop userprofilepic1 text-uppercase">{{firstName.charAt(0)}}</p>
                    </div>
                    <img v-if="profilePictureLink" :src="profilePictureLink" oncontextmenu="return false" alt="profilepic" class="img-fluid rounded-circle loadingBgImg">
                  </div>
                  <div class="col-3" v-else>
                    <img src="../assets/Profile_placehlder.svg" class="img-fluid" alt="profilepic"/>
                  </div>
                  <div class="col ml-2">
                    <label class="d-flex flex-column text-capitalize">
                      <span class="fontsize16 proximanova-semibold black30" v-if="!firstName">Profile Name</span>
                      <span class="fontsize16 proximanova-semibold black30" v-else>{{firstName}} {{lastName}}</span>
                      <span class="fontsize12 black30 proximanova" v-if="!designation">Designation</span>
                      <span class="fontsize12 black30 proximanova" v-else>{{designation}}</span>
                      <span class="fontsize12 black30 proximanova" v-if="!companyName">Place</span>
                      <span class="fontsize12 black30 proximanova" v-else>{{companyName}}</span>
                    </label>
                  </div>
                </div>
                <div class="row"  v-if="userType !== 'InternalUser'">
                  <div class="col-3 mr-2 ml-2"></div>
                  <label class="addphoto mr-1">Profile Strength</label>
                  <img src="../assets/Star_VeryLow.svg" class="img12 mr-1" alt="star"/>
                  <label class="proximanova black80 fontsize12  profileStrengthValue">{{profilestrengthLabel}}</label>
                </div>
                <div class="row mb-2 d-flex"  v-if="userType !== 'InternalUser'">
                  <div class="col-4 mr-2 ml-2"><span v-if="currentPlanDetails !== null" class="fontsize12 text-nowrap proximanova-bold black">Current plan</span></div>
                  <button class="btn text-center tryPremiumbtn1 fontsize14 borderradius20 mouseoverbtn2 backgroundcolorblack white" @click="TryPremium">
                    <span v-if="currentPlanName !== null">{{currentPlanName}} plan</span><span v-else>Try Premium </span>
                  </button>
                </div>
                <div class="ml-1 pl-2 p-1 mouseoveranimate" @click="navToMyProfile"  v-if="userType !== 'InternalUser'">
                  <img
                    src="../assets/ProfileDetails.svg"
                    class="img-fluid mr-2 pointer"
                    alt="profileinfo"
                  />
                  <label class="fontsize12 proximanova-semibold black ml-1 pointer">View My Profile</label>
                </div>
                <div class="line ml-1"  v-if="userType !== 'InternalUser'"></div>
                <div class="pl-2 mb-1 p-1 mouseoveranimate" @click="routetoRefer"  v-if="userType !== 'InternalUser'">
                  <img src="../assets/refer_sidemenu_black.svg" width="24px" class="img-fluid ml-1 mr-2 pointer" alt="paymentmethods"/>
                  <label class="fontsize12 proximanova-semibold black ml-1 pointer">Invite Friends</label>
                </div>
                <div class="pl-2 mb-1 p-1 mouseoveranimate" @click="navToPaymentMethods"  v-if="userType !== 'InternalUser'">
                  <img src="../assets/PaymentMethods.svg" class="img-fluid mr-2 pointer" alt="paymentmethods"/>
                  <label class="fontsize12 proximanova-semibold black ml-1 pointer">Payment Methods</label>
                </div>
                <div class="pl-2 p-1 mouseoveranimate" @click="navToPurchaseHistory"  v-if="userType !== 'InternalUser'">
                  <img src="../assets/PurchaseHistory.svg" class="img-fluid mr-2 pointer" alt="puchasehistory"/>
                  <label class="fontsize12 proximanova-semibold black ml-1 pointer">Payment History</label>
                </div>
                <div class="line ml-1 d-block d-md-none"  v-if="userType !== 'InternalUser'"></div>
                <div class="pl-2 mb-1 p-1 mouseoveranimate d-block d-md-none" @click="downloadHelpBrochure"  v-if="userType !== 'InternalUser'">
                  <img src="../assets/help.png" width="32" class="img-fluid mr-2 pointer" alt="help"/>
                  <label class="fontsize12 proximanova-semibold black ml-1 pointer">Help</label>
                </div>
                <div class="pl-2 p-1 mouseoveranimate d-block d-md-none" @click="NavToReportIssue"  v-if="userType !== 'InternalUser'">
                  <img src="../assets/PrivacySettings.svg" class="img-fluid mr-2 pointer" alt="support"/>
                  <label class="fontsize12 proximanova-semibold black ml-1 pointer">Support Center</label>
                </div>
                <div class="line ml-1"></div>
                <div class="mb-1 pl-2 p-1 mouseoveranimate" @click="navToPrivacy"  v-if="userType !== 'InternalUser'">
                  <img
                    src="../assets/PrivacySettings.svg"
                    class="img-fluid mr-2 pointer"
                    alt="settings"
                  />
                  <label class="fontsize12 proximanova-semibold black pointer">Privacy Settings</label>
                </div>
                <div class="mb-3 pl-2 p-1 mouseoveranimate">
                  <img
                    src="../assets/SignOut.svg"
                    class="img-fluid mr-2 pointer"
                    alt="signout"
                    @click="logout"
                  />
                  <label class="fontsize12 proximanova-semibold black pointer" @click="logout">Sign Out</label>
                </div>
              </div>
            </popover>
          </div>
          <!-- <div class="d-block d-sm-block d-md-none "  v-if="userType !== 'InternalUser'">
            <img src="../assets/more_options_icon.svg" v-popover:foo4 class=" more_option" alt="moremenu">
          </div> -->
          <div class="mt-3 mr-2 d-none d-sm-block ml-md-1 "  v-if="userType !== 'InternalUser'">
            <div class="circle-button">
              <img v-popover:helppop src="../assets/Help.svg" id="helppopupicon" class="help " alt="help"/>
            </div>
            <popover name="helppop" class="helppopover">
              <div class="p-2">
                <div class="pl-2 p-1 mouseoveranimate" @click="downloadHelpBrochure" v-if="userType !== 'InternalUser'">
                  <img src="../assets/help.png" width="30px" class="img-fluid mr-2 pointer" alt="help"/>
                  <label class="fontsize12 proximanova-semibold black ml-1 pointer">Help </label>
                </div>
                <div class="mb-1 pl-2 p-1 mouseoveranimate" @click="NavToReportIssue"  v-if="userType !== 'InternalUser'">
                  <img src="../assets/PrivacySettings.svg" class="img-fluid mr-2 pointer" alt="settings"/>
                  <label class="fontsize12 proximanova-semibold black pointer">Support Center</label>
                </div>
              </div>
            </popover>
          </div>
          <div class="mt-3 mr-1 mr-md-3  d-sm-block ml-md-1"  v-if="userType !== 'InternalUser'">
            <!-- <router-link to="/" tag="a"> -->
            <div class="circle-button">
              <img src="../assets/Notifications.svg" alt="notifications" v-popover:foo4 class="notification " id="notificationpopupicon" />
              <span class="badge badge-light" v-if="totalNotificationCount > 0">{{totalNotificationCount}}</span>
            </div>
            <!-- </router-link> -->
          </div>
        </div>
      </div>
    </div>
    <popover name="foo4" class="notificationpop" id="notificationpop">
      <div class="no-gutters col-lg-12 container-fluid">
        <!-- <div class="d-flex pl-4 pt-2 d-none d-sm-block d-md-none">
          <div @click="displayHelpsection = true">
            <img src="../assets/Help.svg" class="img-fluid mr-4" alt="help" />
          </div>
          <span @click="displayHelpsection = false">
            <img src="../assets/Notifications.svg" class="img-fluid" alt="notifications"/>
            <span class="badge badge-light innerbadge" v-if="totalNotificationCount > 0">{{totalNotificationCount}}</span>
          </span> 
        </div>
        <hr class="hr"> -->
        <div class="head" v-if="!displayHelpsection">
          <span class="fontsize12 black60 proximanova pl-3">Notifications <span v-if="totalNotificationCount>0">- {{totalNotificationCount}}</span></span>
        </div>
        <div class="col-12 card-header mt-2 mb-2 container-fluid " v-if="!displayHelpsection">
          <div class=" no-gutters ">
            <ul class="nav nav-tabs font12-boldcolor d-flex justify-content-around">
              <li class="nav-item p-2">
                <a
                  class="proximanova pointer"
                  :class="{'proximanova-semibold blue border-tab':activeClass == 'notifications'}"
                  id="notifications"
                  @click="toggleActiveClass('notifications')"
                >Notifications</a>
              </li>
              <li class="nav-item p-2">
                <a
                  class="proximanova pointer"
                  :class="{'proximanova-semibold blue border-tab':activeClass == 'jobs'}"
                  id="jobs"
                  @click="toggleActiveClass('jobs')"
                >Jobs</a>
              </li>
              <li class="nav-item p-2">
                <a
                  class="proximanova pointer"
                  :class="{'proximanova-semibold blue border-tab':activeClass == 'videos'}"
                  id="videos"
                  @click="toggleActiveClass('videos')"
                >Videos</a>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="displayHelpsection">
          <div class="p-2">
            <div class="pl-2 p-1 mouseoveranimate" @click="downloadHelpBrochure" v-if="userType !== 'InternalUser'">
              <img src="../assets/Help.svg" class="img-fluid mr-2 pointer" alt="help"/>
              <label class="fontsize12 proximanova-semibold black ml-1 pointer">Help</label>
            </div>
            <div class="mb-1 pl-2 p-1 mouseoveranimate" @click="NavToReportIssue"  v-if="userType !== 'InternalUser'">
              <img src="../assets/PrivacySettings.svg" class="img-fluid mr-2 pointer" alt="settings"/>
              <label class="fontsize12 proximanova-semibold black pointer">Support Center</label>
            </div>
          </div>
        </div>
        <div v-else>
        <div v-if="notificationsLoader">
          <img src="../assets/loading_gif1.gif" class="instanceloader pt-3 pb-3" alt="loading">
        </div> 
        <div v-else>
        <div class="container-fluid pl-3 pr-3 pt-1" v-if="notifications">
          <div v-if="notificationList.length > 0">
          <div class="col pt-2 pb-2 mb-2 d-flex border-0 noty rounded" v-for="(item, index) in notificationList" :key="index">
            <div class="col-2">
              <!-- <img v-if="!item.profilePictureLink" src="../assets/Profile_placehlder.svg" class="img-fluid rounded-circle notyimg"/> -->
              <div v-if="!item.profilePictureLink" id="profImage" class="othercircles text-center white fontsize14 rounded-circle white" :class="item.userName.charAt(0)">
                <span class="white fontsize14 defpaddingtop text-uppercase">{{item.userName.charAt(0)}}</span>
              </div>
              <img  v-if="item.profilePictureLink" :src="item.profilePictureLink" @error="item.profilePictureLink = null" alt="profilepic" class="img-fluid rounded-circle notyimg loadingBgImg"/>
            </div>
            <div class="pl-3 col-11 notybody">
              <div class=" d-flex justify-content-between">
                <p class="fontsize12 black60 proximanova">{{item.userName}} <span v-if="(item.count > 1) && (item.subject != 'VIEWPROFILE')"> & {{item.count -1 }} other's</span></p>
                <div class="fontsize12 black30 proximanova">
                  <!-- <p v-if="item.lastUpdateD">{{ item.lastUpdatedD | moment("hh:mm a") }}</p>
                  <p v-else>{{ item.creationD | moment("hh:mm a") }}</p> -->
                  <p v-if="item.lastUpdatedD">{{item.lastUpdatedD | moment("from", "now", true)}} ago</p>
                  <!-- <p v-else>{{ item.creationD | moment("from", "now", true) }}</p> -->
                </div>
              </div>
              <div >
                <p class="fontsize12 black80 proximanova" v-if="item.message">{{item.message.substr(0,70)}}...</p>
              </div>
            </div>
          </div>
          <div class="text-center">
            <p class="coloredfont12 p-1 pb-3" @click="ViewAllNotifications">View all Notifications</p>
          </div>
          </div>
          <div v-else>
            <span class="proximanova black80 fontsize14 pt-3 pb-3 d-flex justify-content-center" >No Notifications Found</span>
          </div>
        </div>
        <div class="container-fluid p-2" v-if="jobs">
          <div v-if="jobnotificationList.length > 0">
            <div class="col pt-2 pb-2 mb-2 d-flex border-0 noty rounded" v-for="(item, index) in jobnotificationList" :key="index">
              <div class="col-2">
                <div v-if="!item.companyLogoLink" id="profImage" class="othercircles text-center white fontsize14 rounded-circle white" :class="item.companyName.charAt(0)">
                  <span class="white fontsize14 defpaddingtop text-uppercase">{{item.companyName.charAt(0)}}</span>
                </div>
                <img  v-if="item.companyLogoLink" :src="item.companyLogoLink" alt="profilepic" class="img-fluid rounded-circle notyimg loadingBgImg"/>
              </div>
              <div class="pl-3 col-11 notybody">
                <div class=" d-flex justify-content-between">
                  <span class="black60 proximanova fontsize12">{{item.jobTitle}}</span>
                  <div class="fontsize12 black30 proximanova">
                    <p v-if="item.creationD">{{item.creationD | moment("from", "now", true)}} ago</p>
                  </div>
                </div>
                <span class="black60 proximanova fontsize12">{{item.companyName}}, {{item.cityName}}</span>
                <div >
                  <p class="fontsize12 black80 proximanova" v-if="item.messageBody">{{item.messageBody}}</p>
                </div>
              </div>
            </div>
            <div class="text-center">
              <p class="coloredfont12 p-1 pb-3" @click="ViewAllNotifications">View all Notifications</p>
            </div>
          </div>
          <div v-else>
            <span class="proximanova black80 fontsize14 pt-3 pb-3 d-flex justify-content-center" >No Job Notifications Found</span>
          </div>
        </div>
        <div class="container-fluid p-2" v-if="videos">
          <div v-if="videonotificationList.length > 0">
          <div class="col pt-2 pb-2 mb-2 d-flex border-0 noty rounded" v-for="(item, index) in videonotificationList" :key="index">
            <div class="col-2">
              <div v-if="!item.profilePictureLink" id="profImage" class="othercircles text-center white fontsize14 rounded-circle white" :class="item.userName.charAt(0)">
                <span class="white fontsize14 defpaddingtop text-uppercase">{{item.userName.charAt(0)}}</span>
              </div>
              <img  v-if="item.profilePictureLink" :src="item.profilePictureLink" @error="item.profilePictureLink = null" alt="profilepic" class="img-fluid rounded-circle notyimg loadingBgImg"/>
            </div>
            <div class="pl-3 col-11 notybody">
              <div class=" d-flex justify-content-between">
                <p class="fontsize12 black60 proximanova">{{item.userName}} <span v-if="(item.count > 1) && (item.subject != 'VIEWPROFILE')"> & {{item.count -1 }} other's</span></p>
                <div class="fontsize12 black30 proximanova">
                  <p v-if="item.lastUpdatedD">{{item.lastUpdatedD | moment("from", "now", true)}} ago</p>
                </div>
              </div>
              <div >
                <p class="fontsize12 black80 proximanova" v-if="item.message">{{item.message.substr(0,70)}}...</p>
              </div>
            </div>
          </div>
          <div class="text-center">
            <p class="coloredfont12 p-1 pb-3" @click="ViewAllNotifications">View all Notifications</p>
          </div>
          </div>
          <div v-else>
            <span class="proximanova black80 fontsize14 pt-3 pb-3 d-flex justify-content-center" >No Video Notifications Found</span>
          </div>
        </div>
        </div>
        </div>
      </div>
    </popover>
    <no-profile-id-modal-component v-if="displayNoProfileModalComponent" @closeNoProfileIdModal="closeNoProfileIdModal"></no-profile-id-modal-component>
    <updateVersioonModal v-if="updateVersioonModal" @closeversion = "cloaseUpdateVersionModal"></updateVersioonModal>
  </div>
</template>
<script>
// import router from '../router';
import httpuserprofile from '../js/http-userprofile.js'
import httpuserdetails from "@/js/http-userdetails.js";
import httpjob from "@/js/http-postjob.js"
import moment from 'vue-moment'
import moment1 from 'moment'
import router from '../router'
import clickOutside from '../directive';
import postvideomodal from '../components/postVideoModal.vue'
import updateVersioonModal from '../components/VersionUpdate.vue'
import NoProfileIdModalComponent from '../components/NoprofileIdModal.vue'
import wndata from '../js/wn_data.json'
import sessionUtils from '@/js/session-util.js'
import commonUtils from '../js/common-utils';
import $ from 'jquery'
import { bus } from "../main";
export default {
  data() {
    return {
      postajob : require('../assets/PostAJob.svg'),
      businessIcon : require('../assets/BusinessIconBlack.svg'),
      postavideo : require('../assets/Post_Video.svg'),
      jobsList:['Product','Product Designer','Sr Product Designer','Product Designer 2'],
      activeClass: "notifications",
      notifications : true,
      jobs : false,
      videos : false,
      profileId: null,
      profilePictureLink : '',
      getuseraliasname : null,
      firstName : '',
      lastName : '',
      companyName : '',
      designation : '',
      displayHelpsection : false,
      notificationList : [],
      videonotificationList : [],
      jobnotificationList : [],
      totalNotificationCount : 0,
      globalSearchLoader : false,
      notificationsLoader : true,
      searchText: '',
      searchList : [],
      searchType: "people",
      searchBypeople: true,
      searchBycompany : false,
      searchByjobs: false,
      activeField: false,
      resultCount: null,
      searchimg: require('../assets/Search.svg'),
      postavideomodalopen : false,
      profilePercentage : null,
      profilestrengthLabel : 'Very Low',
      remainingDaysLeft : null,
      userPrivacyVersion : null,
      userTermsConditionVersion : null,
      updateVersioonModal : false,
      //business popup
      businessAccountSvg : require('../assets/BusinessAccountpop.svg'),
      postaJobSvg : require('../assets/PostaJobpop.svg'),
      recruiterSvg : require('../assets/Recruiterspop.svg'),
      currentPlanDetails : null,
      currentPlanName : null,
      displayNoProfileModalComponent : false,
      userType : null
    };
  },
  components: {
    postvideomodal,
    updateVersioonModal,
    NoProfileIdModalComponent
  },
  created() {
    this.getUserByID()
    var that = this;
    // this.userType = localStorage.getItem("userType");
    setInterval(function(){ 
      that.profilestrengthLabel = that.$store.state.profileStrength;
      that.totalNotificationCount = that.$store.state.notificationCount;
      // that.profilePictureLink = that.$store.state.profilePicLink;
    }, 1000)
    bus.$on('updatingProfilePictureLink', (data) => {
      if(data){
        this.profilePictureLink = data;
      }
    })
    bus.$on('updateActivePlanName', (data) => {
      if(data === 'NoPlan'){
        this.currentPlanName = null;
        this.currentPlanDetails = null;
      }else{
        this.currentPlanName = data;
      }
    })
    bus.$on('updateProfileInformation', (data) => {
      if(data){
        this.getUserByID()
      }
    })
    this.getUserTermsandPrivacyVersions()
  },
  // watch:{
  //   searchText: function(value){
  //     this.searchByUsername(value);
  //   }
  // },
  methods: {
    closeNoProfileIdModal(){
      this.displayNoProfileModalComponent = false;
    },
    currentActivePlan(){
      httpuserprofile.get('/userprofile/getCurrentSubscriptionPlan?profileId='+this.profileId+'&status=y')
      .then((response) => {
        console.log("current plan in top header", response)
        if(response.data.length > 0){
          let currentPlanDetails = response.data[0]
          this.currentPlanDetails = currentPlanDetails;
          this.currentPlanName = currentPlanDetails.planType;
          localStorage.setItem('epCustomerId', currentPlanDetails.epcustomerId)
        }
      }).catch((e) => {
        console.log(e.response)
      })
    },
    routeToJobs(){
      this.activeField = false;
      document.getElementById("dropdown").style.display = "none"; 
      // sessionUtils.setSelectedSearchTab('job')
      console.log('enter')
      // this.$router.push({name: 'searchResults', params: { text: this.$store.state.searchtext}});
      this.$router.push({name: 'searchResults', params: { text: this.searchText , searchType : 'job'}});
    },
    getEasyPayCustomerId(){
      httpuserprofile.get('/userprofile/getSubscriptionListById?profileId='+this.profileId)
      .then((response) => {
        console.log("current plan in top header", response)
        let records = response.data
        if(response.data.length > 0){
          for(var i =0; i < records.length; i++){
            if(records[i].planType === "Customer Registration"){
              localStorage.setItem('epCustomerId', records[i].epcustomerId)
            }
          }
        }
      }).catch((e) => {
        console.log(e.response)
      })
    },
    getLastUpdatedPlanDetails(){
      httpuserprofile.get('/userprofile/getSubscriptionDateByprofileId?profileId='+this.profileId)
      .then((response) => {
        console.log("last updated record in topheader", response)
        let records = response.data
        if(response.data.length > 0){
          let lastUpdatedRecord = records[0]
          localStorage.setItem('epCustomerId', lastUpdatedRecord.epcustomerId)
          console.log("last updated record : ", lastUpdatedRecord)
          var dateFrom = moment1(lastUpdatedRecord.startD).format("DD/MM/YYYY");
          var dateTo = moment1(lastUpdatedRecord.endD).format("DD/MM/YYYY");
          var dateCheck = moment1(new Date()).format("DD/MM/YYYY");

          var dateFrom1 = dateFrom.split("/");
          var dateTo1 = dateTo.split("/");
          var dateCheck1 = dateCheck.split("/");

          var dateFrom2 = new Date(dateFrom1[2], parseInt(dateFrom1[1])-1, dateFrom1[0]);  // -1 because months are from 0 to 11
          var dateTo2   = new Date(dateTo1[2], parseInt(dateTo1[1])-1, dateTo1[0]);
          var dateCheck2 = new Date(dateCheck1[2], parseInt(dateCheck1[1])-1, dateCheck1[0]);
          // if(dateCheck2 >= dateFrom2 && dateCheck2 <= dateTo2 && lastUpdatedRecord.status==='Y'){
          if(dateCheck2 >= dateFrom2 && dateCheck2 <= dateTo2 && lastUpdatedRecord.paymentStatus == 'ACTIVE'){
            console.log("Current plan available")
            this.currentPlanDetails = response.data[0];
            this.currentPlanName = this.currentPlanDetails.planType;         
          }
        }
      }).catch((e) => {
        console.log(e.response)
      })
    },
    cloaseUpdateVersionModal() {
      this.updateVersioonModal = false
    },
    moveToBusinessAccount() {
      this.openInNewTab(wndata.companyAccountWebapp)
    },
    moveToPostJobModule(){
      this.openInNewTab(wndata.postajobModuleWebapp)
    },
    moveToBusinessSignUp(){
      this.openInNewTab(wndata.companyAccountWebapp)
    },
    openInNewTab(href) {
      var x = document.createElement('a')
      x.target = '_blank'
      x.href = href
      x.click()
    },

    //this will invoke after mouseover the business icon on business popover
    mouseoverBusinessAccount(){
      console.log("check")
      this.businessAccountSvg = require('../assets/BusinessAccountpopBlue.svg')
    },
    mouseleaveBusinessAccount(){
      this.businessAccountSvg = require('../assets/BusinessAccountpop.svg')
    },
    mouseoverPostaJob() {
      this.postaJobSvg = require('../assets/PostaJobpopBlue.svg')
    },
    mouseleavePostaJob(){
      this.postaJobSvg = require('../assets/PostaJobpop.svg')
    },
    mouseoverRecruiter(){
      this.recruiterSvg = require('../assets/RecruiterspopBlue.svg')
    },
    mouseleaveRecruiter(){
      this.recruiterSvg = require('../assets/Recruiterspop.svg')
    },
    getProfileViews : function() {
      httpuserprofile.get('/userprofile/userviewedList?profileId='+this.profileId+'&limit=20')
      .then((response) => {
        if(response.data.rmainingDaysforEndDate !== null) {
          this.remainingDaysLeft = response.data.rmainingDaysforEndDate
          this.$store.state.remainingDays = response.data.rmainingDaysforEndDate
          this.$store.state.trailAccountFlag = response.data.trailAccountFlag
        }else{
          this.$store.state.remainingDays = null
          this.$store.state.trailAccountFlag = response.data.trailAccountFlag
        }
      })
    },
    getUserTermsandPrivacyVersions() {
      httpuserdetails.get("/getuserdataById?userId="+sessionUtils.getUserId())
      .then((response) => {
        console.log("user deatils : ", response)
        this.userPrivacyVersion = response.data.privacyPolicyVersion;
        this.userTermsConditionVersion = response.data.termsConditionsVersion;
        this.checkUpdatedVersion()
      }).catch((e) => {
        console.log(e)
      })
    },
    checkUpdatedVersion() {
      let updatedTermsVersion = localStorage.getItem('termsConditionsVersion')
      let updatedPrivacyVersion = localStorage.getItem('privacyPolicyVersion')
      if( updatedTermsVersion !== null && updatedPrivacyVersion !== null){
        if(this.userTermsConditionVersion !== updatedTermsVersion && this.userPrivacyVersion !== updatedPrivacyVersion) {
          console.log("make call")
          console.log("updatedTermsVersion : ", updatedTermsVersion)
          console.log("updatedPrivacyVersion : ", updatedPrivacyVersion)
          console.log("current terms : ", this.userTermsConditionVersion)
          console.log("current privacy : ", this.userPrivacyVersion)
          this.updateVersioonModal = true
        }
      }
      
    },
    closeModal() {
      this.postavideomodalopen = false;
    },
    navToMyProfile : function() {
      document.getElementById('profilepopupimg').click()
      if(this.profileId){
        this.$store.state.selectedUser = this.getuseraliasname; 
        this.$router.push({name: 'wn', params: { id: this.$store.state.selectedUser}});
      }else{
      router.push({
        name : 'welcome'
      })
      }
    },
    navToPaymentMethods : function() {
      if(this.profileId){
      document.getElementById('profilepopupimg').click()
      router.push({
        name : 'payment_methods'
      })
      }else{
        this.displayNoProfileModalComponent = true;
      }
    },
    routetoRefer: function(){
      if(this.profileId){
        document.getElementById('profilepopupimg').click()
        router.push({
          name : 'referandearn'
        })
      }else{
        this.displayNoProfileModalComponent = true;
      }
    },
    navToPurchaseHistory : function() {
      if(this.profileId){
      document.getElementById('profilepopupimg').click()
      router.push({
        name : 'purchase_history'
      })
      }else{
        this.displayNoProfileModalComponent = true;
      }
    },
    TryPremium : function() {
      if(this.profileId){
      document.getElementById('profilepopupimg').click()
      router.push({
        name : 'Premium'
      })
      }else{
        this.displayNoProfileModalComponent = true;
      }
    },
    navToPrivacy : function() {
      if(this.profileId){
      document.getElementById('profilepopupimg').click()
      router.push({
        name : 'privacy'
      })
      }else{
        this.displayNoProfileModalComponent = true;
      }
    },
    searchClicked(){
      this.searchimg = require('../assets/Search_Click.svg');
    },
    hide(){
      this.searchimg = null;
      // if(document.getElementById('dropdown')){
      //   document.getElementById('dropdown').style.display = 'none';
      // }      
      this.searchimg =  require('../assets/Search.svg');
      this.searchList = [];
      this.searchText = '';      
      this.activeField = false;      
      this.searchType = 'people';
      this.globalSearchLoader = false;
    },
    openPostAVideoModal(){
      if(this.profileId) {
        this.postavideomodalopen=!this.postavideomodalopen;
      }else{
        this.displayNoProfileModalComponent = true;
      }
    },
    changejobimage1 : function() {
      // this.postajob = require('../assets/PostaJobblue.svg');
      this.businessIcon = require('../assets/BusinessIconBlue.svg'),
      document.getElementById('postajobtext').style.color = '#0078FF'
    },
    changejobimage2 : function() {
      // this.postajob = require('../assets/PostAJob.svg')
      this.businessIcon = require('../assets/BusinessIconBlack.svg'),
      document.getElementById('postajobtext').style.color = 'black'
    },
    changepostimage1 : function() {
      this.postavideo = require('../assets/PostaVideoblue.svg')
      document.getElementById('postavideotext').style.color = '#0078FF'
    },
    changepostimage2 : function() {
      this.postavideo = require('../assets/Post_Video.svg')
      document.getElementById('postavideotext').style.color = 'black'
    },
    searchByUsername : function(){    
     
      if(this.profileId) {
      if(this.searchText.length < 3  ){ 
        this.searchList = [];                      
         return;
      }          
      this.globalSearchLoader = true;
      // this.$store.state.searchtext = this.searchText;   
       
      var self = this
      if(this.searchType === 'people') {
        setTimeout(function() {
          console.log("into people")
          httpuserprofile.get('/userprofile/getPeopleUnderSearchBarAsSuggestion?searchText='+self.searchText+'&loggedInUserProfileId='+self.profileId)
          .then(response => {        
            self.searchList = []; 
            self.globalSearchLoader = false;       
            self.searchList = response.data; 
            self.resultCount = response.data.length;
          // this.$store.state.resultCount = response.data.length;
            // self.toggleActiveSearchClass("people");                
          }).catch((e) => {
            self.globalSearchLoader = false;
          })     
        }, 1000);
      }else if(this.searchType === 'job'){
        setTimeout(function() {
          console.log("into job")
          httpuserprofile.get('/userprofile/getPeopleJobSearch?searchText='+self.searchText+'&profileId='+self.profileId)
          .then(response => { 
            console.log(response)       
            self.searchList = [];    
            self.globalSearchLoader = false;    
            self.searchList = response.data; 
            self.resultCount = response.data.length;
          // this.$store.state.resultCount = response.data.length;
            // self.toggleActiveSearchClass("job");                
          }).catch((e) => {
            self.globalSearchLoader = false;
          })     
        }, 1000);
      }else if(this.searchType === 'company'){
        setTimeout(function() {
          console.log("into company")
          httpuserprofile.get('/userprofile/getCompanySearch?searchText='+self.searchText+'&profileId='+self.profileId+'&type=user')
          .then(response => {        
            self.searchList = [];    
            self.globalSearchLoader = false;    
            self.searchList = response.data; 
            self.resultCount = response.data.length;
          // this.$store.state.resultCount = response.data.length;
            // self.toggleActiveSearchClass("company");                
          }).catch((e) => {
            self.globalSearchLoader = false;
          })     
        }, 1000);
      }
      }else{
        this.displayNoProfileModalComponent = true;
      }
    },
    allPeopleResults(){
      this.activeField = false;
      document.getElementById("dropdown").style.display = "none"; 
      // sessionUtils.setSelectedSearchTab('people')
      // this.$router.push({name: 'searchResults', params: { text: this.$store.state.searchtext}});  
      this.$router.push({name: 'searchResults', params: { text: this.searchText, searchType : 'people'}});
      // to open people tab if already in search results screen   
      bus.$emit('openSearchTab', 'people')
      // to update the data based on search text if already in search results screen and people tab
      bus.$emit('updatePeopleSearchResults', true)
      this.searchText = ''
    },
    allJobResults(){
      this.activeField = false;
      document.getElementById("dropdown").style.display = "none"; 
      // sessionUtils.setSelectedSearchTab('job')
      // this.$router.push({name: 'searchResults', params: { text: this.$store.state.searchtext}}); 
      this.$router.push({name: 'searchResults', params: { text: this.searchText, searchType : 'job'}});
      // to open job tab if already in search results screen
      bus.$emit('openSearchTab', 'job')
      // to update the data based on search text if already in search results screen and job tab
      bus.$emit('updateJobSearchResults', true)
      this.searchText = ''
    },
    allCompanyResults(){
      this.activeField = false;
      document.getElementById("dropdown").style.display = "none"; 
      // sessionUtils.setSelectedSearchTab('company')
      // this.$router.push({name: 'searchResults', params: { text: this.$store.state.searchtext}}); 
      this.$router.push({name: 'searchResults', params: { text: this.searchText, searchType : 'company'}});
      // to open company tab if already in search results screen
      bus.$emit('openSearchTab', 'company')
      // to update the data based on search text if already in search results screen and company tab
      bus.$emit('updateCompanySearchResults', true)
      this.searchText = ''
    },
    selectedUser(id){   
      document.getElementById("dropdown").style.display = "none"; 
      this.activeField = false;
      this.$store.state.selectedUser = id;      
      if(sessionUtils.getUserId() === id){
        router.push({
          name : 'welcome'
        })
        
      }else{
        this.$router.push({name: 'wn', params: { id: this.$store.state.selectedUser}});
      }   
      this.searchText = ''
    },
    selectedCompany(id){
      console.log(id,name)
      document.getElementById("dropdown").style.display = "none"; 
      this.activeField = false;
      this.$store.state.selectedCompany = id;
      this.$router.push({name: 'wncompany', params: { id: this.$store.state.selectedCompany}});
      this.searchText = ''
    },
    selectedJob(job) {
      document.getElementById("dropdown").style.display = "none"; 
        this.$store.state.selectedJob = job.jobAliasId; 
        this.$session.set("selectedJobAliasId", job.jobAliasId);
        this.$router.push({
            name : 'viewjob', params: { id: this.$store.state.selectedJob}
        })
        this.searchText = ''
    },
    getUserByID(){     
      httpuserprofile.get('/userprofile/userbyid/'+
      sessionUtils.getUserId()).then(response =>{
          this.profileId = response.data.profileId;
          this.profilePictureLink = response.data.profilePictureLink;
          this.firstName = response.data.firstName;
          this.lastName = response.data.lastName;
          this.getuseraliasname = response.data.aliasName;
          sessionUtils.setUserAliasName(this.getuseraliasname)
          if(response.data.companyDetails){
            this.companyName = response.data.companyDetails.companyName;
          }
          if(response.data.designation){
            this.designation = response.data.designation.roleName
          }
          sessionUtils.setUserProfileId(this.profileId)
          this.fetchNotifications()

          //profilePercentage
          if(this.profileId !== '' && this.profileId !== undefined){
            this.profilePercentage += 10; 
          }
          if(this.profilePictureLink !== '' && this.profilePictureLink !== undefined){
            this.profilePercentage += 5;
          }
          if(response.data.primaryPhoneNumber !== null && response.data.primaryPhoneNumber !== undefined) {
            this.profilePercentage += 10;
            this.$store.state.addedContactInfo = true;
          }
          if(response.data.workExperience && response.data.workExperience.length > 0){
            this.profilePercentage += 20;
            commonUtils.updateLoginUserWorkExperience(response.data.workExperience)
          }
          if(response.data.userEducation && response.data.userEducation.length > 0) {
            this.profilePercentage += 10;
          }
          if(response.data.zipCode) {
            this.profilePercentage +=5;
          }
          if(response.data.userKnowledge && response.data.userKnowledge.length > 0 && response.data.userTechnology.length > 0){
            this.profilePercentage +=10;
          }
          if(response.data.profileVideoId !== null){
            this.profilePercentage +=15;
          }
          if(response.data.resumeVideoId !== null){
            this.profilePercentage +=15
          }
          this.getprofileStrengthLabel()
          if(this.profileId){
          this.getProfileViews()
          // this.currentActivePlan()
          // this.getEasyPayCustomerId()
          this.getLastUpdatedPlanDetails()
          }
        }
      )
    },
    getprofileStrengthLabel : function() {
      //profileStrengthLabel
      if(10 <= this.profilePercentage && this.profilePercentage <= 40){
        this.profileStrengthLabel = "Very Low"
      }else if(41 <= this.profilePercentage && this.profilePercentage <= 70){
        this.profileStrengthLabel = "Average"
      }else if(71 <= this.profilePercentage && this.profilePercentage <= 90){
        this.profileStrengthLabel = "Strong"
      }else if(91 <= this.profilePercentage && this.profilePercentage <= 100){
        this.profileStrengthLabel = "All Stars"
      }
      this.$store.state.profileStrengthPercentage = this.profilePercentage;
      this.$store.state.profileStrength = this.profileStrengthLabel;
    },
    fetchNotifications : function() {
      if(this.profileId) {
        httpuserprofile.get('userprofile/getNotificationList',{
          params: { profileId : this.profileId,
          offset : 0,
          limit : 4 }
        }).then((response) => {
          console.log("notifications : ", response)
          this.notificationsLoader = false;
          let list = response.data.list
          for(var i = 0; i < list.length; i++) {
            if( i < 4) {
              this.notificationList.push(list[i])
            }
          }
          // this.notificationList = response.data.list
          this.totalNotificationCount = response.data.totalRecords
          this.$store.state.notificationCount = this.totalNotificationCount;
        }).catch((error) => {
          this.notificationsLoader = false;
        })
      }else{
        this.notificationsLoader = false;
      }
    },
    fetchVideoNotifications(){
      if(this.profileId) {
        httpuserprofile.get('userprofile/getPostedVideoNotificationList',{
          params: { profileId : this.profileId,
          offset : 0,
          limit : 4 }
        }).then((response) => {
          console.log("notifications : ", response)
          this.notificationsLoader = false;
          let list = response.data.list
          for(var i = 0; i < list.length; i++) {
            if( i < 4) {
              this.videonotificationList.push(list[i])
            }
          }
        }).catch((error) => {
          this.notificationsLoader = false;
        })
      }else{
        this.notificationsLoader = false;
      }
    },
    fetchJobNotifications() {
      if(this.profileId) {
        httpjob.get('postjob/getJobNotificationList',{
          params: { profileId : this.profileId,
          offset : 0,
          limit : 4 }
        }).then((response) => {
          console.log("notifications : ", response)
          this.notificationsLoader = false;
          let list = response.data;
          for(var i = 0; i < list.length; i++) {
            if( i < 4) {
              this.jobnotificationList.push(list[i])
            }
          }
        }).catch((error) => {
          this.notificationsLoader = false;
        })
      }else{
        this.notificationsLoader = false;
      }
    },
    profile: function() {
      this.$router.push("/profile");
    },
    toggleActiveClass(elementId) {
      this.activeClass = elementId;
      this.notificationsLoader = true;
      if(elementId == 'notifications'){
        this.viewNotifications()
      }else if(elementId == 'jobs') {
        this.jobsNotifications()
      }else{
        this.videoNotifications()
      }
    },
    toggleActiveSearchClass(elementId) {
      this.searchList = [];
      this.searchType = elementId;    
      if(elementId == 'people'){      
        this.viewByPeople();
        
      }else if(elementId == 'company') {
        this.viewByCompany();
      }else if(elementId == 'job') {
        this.viewByJobs();
      }
      if(this.searchText.length > 2  ){
        this.searchByUsername()
      }
    },
    viewByPeople: function(){
      this.searchBypeople = true;
      this.searchBycompany = false;
      this.searchByjobs= false;     
    },
    viewByCompany: function(){
      this.searchBypeople = false;
       this.searchBycompany = true;
      this.searchByjobs= false; 
      
    },
    viewByJobs: function(){
      this.searchBypeople = false;
       this.searchBycompany = false;
      this.searchByjobs= true; 
      
      
    },
    downloadHelpBrochure() {
      document.getElementById('helppopupicon').click()
      var link=document.createElement('a');
      document.body.appendChild(link);
      link.href=wndata.worknotionURL+"help_center.pdf"
      link.target = '_blank';
      link.click();
    },
    NavToReportIssue() {
      document.getElementById('helppopupicon').click()
      this.$router.push({
        name : 'reportissue'
      })
    },
    viewNotifications : function() {
      this.notifications = true;
      this.jobs = false;
      this.videos = false;
      this.notificationList = [];
      this.fetchNotifications()
    },
    ViewAllNotifications : function() {
      // console.log("view all notifications");
      if(this.profileId){
      document.getElementById('notificationpopupicon').click()
      this.$router.push({
        name : 'notifications'
      })
      }else{
        this.displayNoProfileModalComponent = true;
      }
    },
    jobsNotifications : function() {
      this.notifications = false;
      this.jobs = true;
      this.videos = false;
      this.jobnotificationList = [];
      this.fetchJobNotifications()
    },
    videoNotifications : function() {
      this.notifications = false;
      this.jobs = false;
      this.videos = true;
      this.videonotificationList = [];
      this.fetchVideoNotifications()
    },
    logout: function() {
      //make a rest call to capture a logout for the user
      this.$store.state.notificationCount = 0
      this.$session.clear();
      localStorage.setItem('isLoggedin', false);
      this.$session.destroy();
      localStorage.clear();
      this.$router.push("/signin");
      location.reload(true)
    }
  }
};
</script>
<style scoped>
.instanceloader{
  width: 10%;
  margin-left: 46%;
}
.input-group-text {
  padding: 0px 0px 0px 0px !important;
}
.input-group-text1 {
  padding: 0px 0px 0px 0px !important;
}
.loadingBgImg{
  background: transparent url('../assets/loading_gif1.gif') center no-repeat;
  background-size: 30px 30px;
}
.nav-item:hover {
  background-color: rgba(161, 166, 179,0.3);
  border-radius: 20px;
}
.nav-opacity{
  opacity: 0.6;
}
.form-control {
  background-color: rgb(236, 236, 238) !important;
  border: 0px solid #ced4da !important;
  /* border-radius: 0px 10px 10px 0px !important; */
}
.hover {
  cursor: pointer;
  /* color: #0078FF; */
}
.hover1 {
  cursor: pointer;
  /* color: #0078FF; */
}
.tryPremiumbtn{
  /* height: 15px; */
  font-size: 13px;
  padding: .2rem .45rem !important;
  float: right;
}
.tryPremiumbtn1{
  padding: .2rem .45rem !important;
}
.form-control:focus{
  outline: none !important;
    box-shadow: none !important;    
}

.searchinput {
    padding: 0em !important;
    font-size: 12px !important;
  }

.circle-button{
  border-radius: 50%;
  padding: 0 5px 5px 5px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.circle-button:hover{
  animation: circle-anim 0.3s ease forwards;
  transition: all 0.4s ease;
}
@keyframes circle-anim{
  0% {
    background-color: white;
  }
  100%{
    background-color: #F0F2F5;
  }
}

/* for search drop down */
.dropdown-menu{
    display:block;    
    color: black;
    box-shadow: 0px 8px 16px 0px rgba(0,23,56,0.1);
    border: none;
    min-width:100%;
    margin-top: 0px;   
    border-radius: 10px  !important;
}
.list-group-item {
  position: relative;
    display: block;
    padding: 0.5rem 0.25rem;
    background-color: #fff;
    border: none;
    /* opacity: 60% */
}
.input-group-append{
  z-index : 100;
}
#searchList:active{
  border: 2px solid #0078FF;
  background-color: #d6e9ff !important;
}

 #searchList:hover { background-color:rgba(221, 223, 229,0.4);
  cursor: pointer; 
}
#profImage{
  width: 30px;
  height: 30px;
}
.othercircles{
  line-height: 30px;
}
.border{
  border-radius: 4px;
}
.border-color{
  border-radius: 4px;
  border: 1px solid #D9DCE1;
}
.basic-text1{
  z-index: 5

}
.mouseoveraction1:hover > .margintop1{
  color: #0078FF;
}
.colored-border {
  border-color: #007AFF !important;
}
.bigger-font{
  font-size: 16px;
}

.imgborder {
  padding: 11px 15px 10px 10px;
  background-color: rgb(236, 236, 238);
  border-radius: 10px 0px 0px 10px;
}
.imgborder1 {
  padding: 10px 15px 10px 10px;
  background-color: rgb(236, 236, 238);
  border-radius: 0px 10px 10px 0px;
}
.input-border{
  border-radius: 0px 10px 10px 0px;
}
.coloredfont12 {
  color: #fc597f;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
}
.badge {
  position: absolute;
  margin-left: -5%;
  margin-top: 2%;
  background: #fc597f;
  color: white;
  font-size: 9px;
  border-radius: 16px;
}
.innerbadge{
  margin-left: -3.5% !important;
  margin-top: 1% !important;
}
.hr {
  display: none;
  color: rgba(0, 0, 0, 0.025);
  margin-bottom: 0 !important;
}
/* tab view in popover */
li > a {
  color: black;
}
.card-header {
  padding: 5px 10px 5px 10px;
  margin-bottom: 0;
  border-top: 1px solid #d9dce1;
  border-bottom: 1px solid #d9dce1;
}
.col > .col-2 {
  padding-left : 1px;
}
.notyimg {
  height: 30px;
  width: 30px;
}
.notybody {
  margin-left: -15px;
}
.list-text-color{
  color: #0078FF  !important;
  font-family: "Proxima Nova";
  /* font-size: 16px; */
  font-weight: bold;
  letter-spacing: 0;
}
.border-tab{
  border-bottom-style: solid;
  border-bottom-color: #0078FF;
}

.nav-tabs {
  border-bottom: none;
}

.navbar {
  padding: 0px 0px 0px 0px !important;
  z-index: 100;
}
.nav{
  flex-wrap: unset !important;
}
input:focus,
textarea:focus {
  outline: none; /** For Safari, etc **/
  border: transparent;
}
.postbtn{
  cursor: pointer;
}
.postbtn:hover {
  color: #0078FF;
}
.more_option {
  height: 20px;
  margin-top: 1.6em;
  margin-right: 20px;
}
 .list-Font-color{
  /* opacity: 60%; */
  background-color: transparent  !important;
  color: #1F1F1F;
  font-family: "Proxima Nova";
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0;
}
#searchedInput{
  /* z-index: 5; */
  border-radius: 0 10px 10px 0;
}
/* profile */
.mouseoveranimate:hover{
  background-color:rgba(221, 223, 229,0.4);
  /* padding-left: 10px; */
  border-radius: 5px;
}
.dropdown-position-bottom.userpopover {
  top: 71px !important;
  width: 262px !important;
  padding: 10px 10px 0px 10px !important;
}
.vue-popover.dropdown-position-bottom.userpopover:before {
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #fff;
  top: -8px;
  /* right: 50px; */
  left: 130px !important;
  filter: drop-shadow(0px -2px 2px rgba(52, 73, 94, 0.1));
}
/* help popup */
.dropdown-position-bottom.helppopover{
  top: 71px !important;
  width: 220px !important;
  padding: 10px 10px 0px 10px !important;
}
.vue-popover.dropdown-position-bottom.helppopover:before {
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #fff;
  top: -8px;
  /* right: 50px; */
  left: 100px !important;
  filter: drop-shadow(0px -2px 2px rgba(52, 73, 94, 0.1));
}
/* post */
.dropdown-position-bottom.postpopover {
  top: 71px !important;
  width: 200px !important;
  padding: 8px 0px 4px 10px !important;
  border-radius: 5px;
}
.vue-popover.dropdown-position-bottom.postpopover:before {
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #fff;
  top: -8px;
  /* right: 50px; */
  left: 130px !important;
  filter: drop-shadow(0px -2px 2px rgba(52, 73, 94, 0.1));
}
.search-input {
  background-color: rgb(236, 236, 238) !important;
  border-radius: 10px 10px 10px 10px;
}
.search-input:hover{
  border: 1px solid #007AFF;
  border-radius: 10px 10px 10px 10px;
}

/* notification popup */
.dropdown-position-bottom.notificationpop {
  top: 71px !important;
  width: 370px !important;
  /* left: 1115px !important; */
  left : 73% !important;
  padding: 10px 0px 0px 0px !important;
}
.vue-popover.dropdown-position-bottom.notificationpop:before {
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #fff;
  top: -8px;
  left: 325px !important;
  filter: drop-shadow(0px -2px 2px rgba(52, 73, 94, 0.1));
}
/* notification popup */
.dropdown-position-bottom.businesspopover {
  top: 71px !important;
  width: 260px !important;
  left: 60% !important;
  padding: 20px !important;
}
.vue-popover.dropdown-position-bottom.businesspopover:before {
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #fff;
  top: -8px;
  left: 50% !important;
  filter: drop-shadow(0px -2px 2px rgba(52, 73, 94, 0.1));
}
.pointer {
  cursor: pointer;
}
p{
  margin-bottom: 0 !important;
}
.noty {
  background-color: rgba(0, 0, 0, 0.025);
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
}
.noty:hover {
  border: 1px solid #0078FF !important;
}
.line {
  display: block;
  height: 1px;
  border: 0;
  border-top: #dddfe5;
  margin: .5em 0;
  padding: 0;
  width: 224px;
  opacity: 0.6;
  background-color: #dddfe5;
}
.line1 {
  display: block;
  height: 1px;
  border: 0;
  padding: 0;
  border: 1px solid #1f1f1f;
  opacity: 0.1;
}
.input-width{
  border: 1px solid #007AFF;
  border-radius: 10px 10px 10px 10px;
}
.searchsubmit {
  background: #007AFF;
  /* color: white;
  padding: 10px;
  border-radius: 10px; */
  width: 41px;
  height: 38px;
  padding: 10px 12px 10px 10px !important;
}
.help, .notification {
  width: 30px;
  margin-top: .3em;
}
.businessbtn{
    background: none;
  }
.overlay{
  z-index: inherit;
}
.defimgmouseover{
  padding: 3px;
  border-radius: 50%;
}
.defimgmouseover:hover{
  border: 1px solid #F0F2F5;
}
.mouseover{
  padding: 3px;
  transition: all 0.2s ease;
  border-radius: 50%;
}
.usericon1{
  width: 35px;
  height: 35px;
  margin-top: .085em;
  z-index: 0;
}
.usericon2{
  width: 43px;
  height: 43px;
  margin-top: .085em;
  z-index: 0;
}
.mouseover:hover{
  animation: circle-anim1 0.3s ease forwards;
  transition: all 0.4s ease;
}
@keyframes circle-anim1{
  0% {
    background-color: white;
  }
  100%{
    background-color: #F0F2F5;
  }
}
.userproicon {
  cursor: pointer;
  width: 33px;
  height: 33px;
  margin-top: .085em;
}
.profile-border{
  padding: 0px 1px 1px 1px;
  border: 2px solid #ced4da;
  border-radius: 50%;
}
.profile-border:hover {
  border: 2px solid gray;
}
@media screen and (min-width: 300px) and (max-width: 350px) {
.input-width{
    width: 230%;
    z-index: 4;
    padding-left: 7px;
  }
  .profile-border{
    padding: 1px 1px 1px 1px;
  }
}
@media screen and (max-width: 1280px) {
  .tryPremiumbtn{
    display: none;
  }
  .tryPremiumbtn1{
    display: block;
  }
}
@media screen and (min-width: 350px) and (max-width: 400px) {
.input-width{
    width: 230%;
    z-index: 4;
    padding-left: 7px;
  }
  .profile-border{
    padding: 1px 1px 1px 1px;
  }
}
@media screen and (min-width: 300px) and (max-width: 400px) {
  .hr{
    display: block;
  }
  .usericon1 {
    width: 35px;
    height: 35px;
    margin-top: 0;
  }
   #searchList:hover { background-color:rgba(221, 223, 229,0.4);
  cursor: pointer; 
  /* border-radius: 4px; */
  }
 
 
  .userproicon {
    width: 33px;
    height: 33px;
    margin-top: 0;
  }
  .rounded{
    padding-right: 30px !important;
    padding-left: 10px  !important;
    border-radius: 15px !important;
  }
 
  /* notification popover */
  .dropdown-position-bottom.notificationpop {
    left: 0px !important;
    width: 360px !important;
  }
  .vue-popover.dropdown-position-bottom.notificationpop:before {
    left: 93% !important;
  }
  

  /* user popover */
  .dropdown-position-bottom.userpopover {
    left: 25% !important;
  }
  .vue-popover.dropdown-position-bottom.userpopover:before {
    left: 210px !important;
  }
  /* help popover */
  .dropdown-position-bottom.helppopover{
    left: 25% !important;
  }
  .vue-popover.dropdown-position-bottom.helppopover:before {
    left: 210px !important;
  }
  /* post popover */
  .dropdown-position-bottom.postpopover {
    left: 30% !important;
  }
  .vue-popover.dropdown-position-bottom.postpopover:before {
    left: 60% !important;
  }
  .internalUserstyles{
    margin-left: 75% !important;
  }
}
@media screen and (min-width: 400px) and (max-width: 500px) {
  .mouseover{
    margin-right: 10px !important;
  }
  .profile-border{
    padding: 1px 1px 1px 1px;
  }
  .input-width{
    width: 230%;
    z-index: 4;
    padding-left: 7px;
  }
   #searchList:hover { 
     background-color:rgba(221, 223, 229,0.4);
  cursor: pointer; 
  }
  .userprofilepic{
    margin-top: 3px !important;
  }
  .userprofilepic1{
    margin-top: 8px !important;
  }
  .internalUserstyles{
    margin-left: 75% !important;
  }
}
@media screen and (max-width: 400px){
  .userprofilepic{
    margin-top: 3px !important;
  }
  .userprofilepic1{
    margin-top: 8px !important;
  }
}
@media screen and (min-width: 400px) and (max-width: 600px) {
  .hr{
    display: block;
  }
  #searchList:hover { background-color:rgba(221, 223, 229,0.4);
  cursor: pointer; 
  border-radius: 4px;}

.input-width{
    padding-left: 7px;
  }
  .usericon1 {
    width: 35px;
    height: 35px;
    margin-top: 0;
  }
  .userproicon {
    width: 33px;
    height: 33px;
    margin-top: 0;
  }
  .rounded{
    padding-right: 30px !important;
    padding-left: 10px  !important;
    border-radius: 15px !important;
  }
  .searchinput {
    width: 300%;
  }
  /* notification popover */
  .dropdown-position-bottom.notificationpop {
    left: 7% !important;
    width: 360px !important;
  }
  .vue-popover.dropdown-position-bottom.notificationpop:before {
    left: 95% !important;
  }

  /* user popover */
  .dropdown-position-bottom.userpopover {
    left: 28% !important;
  }
  .vue-popover.dropdown-position-bottom.userpopover:before {
    left: 210px !important;
  }
  /* user popover */
  .dropdown-position-bottom.helppopover {
    left: 28% !important;
  }
  .vue-popover.dropdown-position-bottom.helppopover:before {
    left: 210px !important;
  }
  /* post popover */
  .dropdown-position-bottom.postpopover {
    left: 120px !important;
  }
  .vue-popover.dropdown-position-bottom.postpopover:before {
    left: 150px !important;
  }
}
@media screen and (max-width: 600px) and (min-width: 500px) {
  /* notification popover */
  .dropdown-position-bottom.notificationpop {
    left: 25% !important;
    width: 360px !important;
  }
  .vue-popover.dropdown-position-bottom.notificationpop:before {
    left: 339px !important;
  }

  /* user popover */
  .dropdown-position-bottom.userpopover {
    left: 42% !important;
  }
  .vue-popover.dropdown-position-bottom.userpopover:before {
    left: 80% !important;
  }
  /* help popover */
  .dropdown-position-bottom.helppopover {
    left: 42% !important;
  }
  .vue-popover.dropdown-position-bottom.helppopover:before {
    left: 80% !important;
  }
  /* post popover */
  .dropdown-position-bottom.postpopover {
    left: 30% !important;
  }
  .vue-popover.dropdown-position-bottom.postpopover:before {
    left: 150px !important;
  }
}
@media screen and (max-width: 900px) and (min-width: 600px) {
  .badge{
    margin-left: -3% !important;
  }
  .profile-border{
    padding: 0px 1px 1px 1px;
  }
  .rounded {
    padding-right: 35px;
    border-radius: 15px !important;
  }
  .input-width{
    padding-left: 8px;
  }
 #searchList:hover { background-color:rgba(221, 223, 229,0.4);
  cursor: pointer; 
  border-radius: 4px;}
  /* notification popover */
  .dropdown-position-bottom.notificationpop {
    left: 395px !important;
  }
  .vue-popover.dropdown-position-bottom.notificationpop:before {
    left: 325px !important;
  }

  /* user popover */
  .dropdown-position-bottom.userpopover {
    left: 400px !important;
  }
  .vue-popover.dropdown-position-bottom.userpopover:before {
    left: 210px !important;
  }
  /* help popver */
  .dropdown-position-bottom.helppopover {
    left: 500px !important;
  }
  .vue-popover.dropdown-position-bottom.helppopover:before {
    left: 175px !important;
  }
  /* post popover */
  .dropdown-position-bottom.postpopover {
    left: 400px !important;
  }
  .vue-popover.dropdown-position-bottom.postpopover:before {
    left: 130px !important;
  }
  .internalUserstyles{
    margin-left: 60% !important;
  }
}
@media screen and (min-width: 900px) and (min-width: 1295px) {
  /* notification popover */
  .dropdown-position-bottom.notificationpop {
    left: 70% !important;
  }
  #searchList:hover { background-color:rgba(221, 223, 229,0.4);
  cursor: pointer; 
  border-radius: 4px;}
  
}
@media screen and (max-width: 900px) and (min-width: 770px) {
  .dropdown-position-bottom.userpopover {
    left: 54% !important;
  }
  .dropdown-position-bottom.helppopover {
    left: 54% !important;
  }
  .dropdown-position-bottom.notificationpop {
    left: 53% !important;
  }
  .dropdown-position-bottom.postpopover {
    left: 54% !important;
  }
}
@media screen and (min-width: 1296px)  {
  /* notification popover */
  .dropdown-position-bottom.notificationpop {
    left: 73% !important;
  }
  #searchList:hover { background-color:rgba(221, 223, 229,0.4);
  cursor: pointer; 
  border-radius: 4px;}
  
}
</style>
